<template>
    <div
        class="colour-icon"
        :class="ragColour"
        v-tooltip.top="tooltip"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { TAccess } from '@/types/general/TAccess.ts';

const props = defineProps<{
    access: TAccess;
}>();

type RagColour = 'red' | 'yellow' | 'green';

const PROPS_BY_ACCESS: Record<TAccess, { colour: RagColour; tooltip: string }> = {
    Full: { colour: 'green', tooltip: 'You have full access to this content' },
    Partial: { colour: 'yellow', tooltip: 'You have partial access to this content' },
    Free: { colour: 'yellow', tooltip: 'You have access to free content' },
    None: { colour: 'red', tooltip: 'You have no access to this content' },
};

const ragColour = computed<RagColour>(() => PROPS_BY_ACCESS[props.access].colour);
const tooltip = computed<string>(() => PROPS_BY_ACCESS[props.access].tooltip);

</script>

<style lang="scss" scoped>

.colour-icon {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;

    &.red {
        background-color: var(--dangerRed);
    }

    &.yellow {
        background-color: var(--warningYellow);
    }

    &.green {
        background-color: var(--successGreen);
    }
}

</style>
